gsap.registerPlugin(ScrollTrigger);

let sections = gsap.utils.toArray(".timeline__item");

sections.forEach((section, index) => {
  ScrollTrigger.create({
    trigger: section,
    // markers: true,
    start: 'top center+=10%',
    end: 'bottom center+=10%',
    onEnter: () => {
        section.classList.add("active");
    },
    onLeaveBack: () => {
        section.classList.remove("active");
    }
  });
});    